'use es6';

import { Set as ImmutableSet, OrderedMap } from 'immutable';
import { formatAdWordsAccountId } from './Utils';
import Networks from './Networks';
import AdAccountStatus from '../lib/AdAccountStatus';
import text from 'I18n/utils/unescapedText';

const getPixelName = (network, accountId, accountName) => {
  const displayName = accountName || accountId;

  switch (network) {
    case Networks.FACEBOOK:
      return text('ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.facebookDefaultName', {
        accountName: displayName
      });

    case Networks.ADWORDS:
      return `${accountName} (${formatAdWordsAccountId(accountId)})`;

    default:
      return text('ADS_ACCOUNT_CONNECTION.audiences.installPixelModal.defaultName', {
        accountName: displayName
      });
  }
};

const getPlaceholderPixel = (adAccount, PixelRecord) => {
  const {
    network,
    accountId,
    accountName
  } = adAccount;
  return new PixelRecord({
    adNetwork: network,
    accessible: adAccount.status === AdAccountStatus.ACTIVE,
    installed: false,
    name: getPixelName(network, accountId, accountName),
    accountId
  });
};

export default ((adAccounts, pixels, PixelRecord) => adAccounts.reduce((pixelMap, adAccount) => {
  const {
    accountId,
    network
  } = adAccount; // Generally, there should only be one pixel per ad account, but in certain cases,
  // pixels can be shared between ad accounts (it appears that this mainly affects Facebook).

  const pixelsAvailableForAccount = pixels.filter(pixel => pixel.adNetwork === network && pixel.accountId === accountId).map(pixel => new PixelRecord(pixel)); // If a pixel has already been created for a given ad account, add that as an option.
  // Otherwise, create a "placeholder" pixel without an id, which will be created
  // before the actual call to install it (unless the account isn't active).

  const adAccountHasOwnPixel = pixelsAvailableForAccount.find(pixel => {
    return pixel.ownerAdAccountId === accountId;
  });
  const availablePixelSet = adAccountHasOwnPixel ? ImmutableSet(pixelsAvailableForAccount) : ImmutableSet(pixelsAvailableForAccount.concat([getPlaceholderPixel(adAccount, PixelRecord)]));

  if (pixelMap.has(network)) {
    return pixelMap.updateIn([network], pixelSet => pixelSet.concat(availablePixelSet));
  } else {
    return pixelMap.set(network, availablePixelSet);
  }
}, OrderedMap()));